import React from 'react';
import{moneyFormatter} from '../library/FormatUtil';
import './ConfirmationPaymentTotal.css';

export default function ConfirmationPaymentTotal(props) {
  return (
    <>
  <tr className='thead--confirmpay'>
        <td className='td--confirm-chargesDueDesc'>Total Amount Paid</td>
        <td className='confirm-page-chargesDue pr-2 text-end'> {moneyFormatter.format(props.confirmationData?.grandTotalAmount)}</td>
        <td></td>
      </tr>
    </>
  )
}
